import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactFCV } from '@types';

import { AirDeliveryForbidden } from './components/AirDeliveryForbidden';
import { MedicinalProductLabel } from './components/MedicinalProductLabel';
import { VoucherUnderProduct } from './components/VoucherUnderProduct';
import { IProductItemBodyWrapperProps } from './model';
import { ProductItemBodyWithLink } from './ProductItemBody';
import { StyledAdditionalProductLabel, StyledProductItemBody, StyledUsedProduct } from './styled';

export const ProductItemBodyWrapper: ReactFCV<IProductItemBodyWrapperProps> = ({
  brand,
  name,
  subName,
  link,
  disabled,
  isGift,
  addedByCoupon,
  isTryItFirst,
  usedProduct,
  onClick,
  maximumQuantity,
  itemQuantity,
  messages,
  isEngraving,
  withDedication,
  priceHistory,
  action,
  discount,
  airDeliveryForbidden,
  voucherDiscount,
  showVoucherUnderProduct,
  customerVouchers,
  setProductVoucherCode,
  isLoyalty,
  isMedicinal,
  enableLoyalty,
  upselling,
  quantity,
  ...rest
}) => {
  const isVoucherUnderProductType = !upselling && !isGift && !addedByCoupon;
  const shouldShowVoucherUnderProduct =
    showVoucherUnderProduct && voucherDiscount && setProductVoucherCode && isVoucherUnderProductType;
  return (
    <StyledProductItemBody disabled={disabled} {...rest}>
      <ProductItemBodyWithLink
        link={link}
        brand={brand}
        name={name}
        subName={subName}
        disabled={disabled}
        isGift={isGift}
        addedByCoupon={addedByCoupon}
        isTryItFirst={isTryItFirst}
        tryItFirstProductLabel={messages?.tryItFirstProductLabel}
        giftProductLabel={messages?.giftProductLabel}
        addedByCouponGiftLabel={messages?.addedByCouponGiftLabel}
        priceHistory={priceHistory}
        action={action}
        discount={discount}
        inSaleLabel={messages?.inSaleLabel}
        inClearanceLabel={messages?.inClearanceLabel}
        loyaltyRewardLabel={messages?.loyaltyRewardLabel}
        isLoyalty={isLoyalty}
        enableLoyalty={enableLoyalty}
      />
      {usedProduct?.descriptions && (
        <StyledUsedProduct>
          {`${usedProduct.descriptions.join(', ')}. `}
          <FormattedMessage
            {...messages.usedProductContentAmount}
            values={{
              amount: usedProduct.volumeInPercent,
            }}
          />
        </StyledUsedProduct>
      )}
      {airDeliveryForbidden && <AirDeliveryForbidden message={messages.airDeliveryForbidden} />}
      {isMedicinal && <MedicinalProductLabel message={messages.medicinalProductLabel} />}
      <StyledAdditionalProductLabel
        data-testid="additional-product-label"
        disabled={disabled}
        itemQuantity={itemQuantity}
        maximumQuantity={maximumQuantity}
        messages={messages}
        isEngraving={isEngraving}
        withDedication={withDedication}
        onClick={onClick}
      />
      {shouldShowVoucherUnderProduct && (
        <VoucherUnderProduct
          voucherCode={voucherDiscount?.voucherCode}
          discountedPrice={voucherDiscount.discountedPrice}
          customerVouchers={customerVouchers}
          setProductVoucherCode={setProductVoucherCode}
          voucherUnderProductLabel={messages.voucherUnderProductLabel}
          quantity={quantity}
        />
      )}
    </StyledProductItemBody>
  );
};
